import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import pages from '../seo-pages.json';

export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/$/, '') || '/';
    const meta = pages[path];
    if (!meta) return;
    const url = `https://mudanzasbritosa.com${path}`;
    document.title = meta.title;
    const set = (attr, key, value) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.append(el); }
      el.content = value;
    };
    set('name', 'title', meta.title);
    set('name', 'description', meta.description);
    set('property', 'og:title', meta.title);
    set('property', 'og:description', meta.description);
    set('property', 'og:url', url);
    set('name', 'twitter:title', meta.title);
    set('name', 'twitter:description', meta.description);
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.href = url;
  }, [pathname]);
  return null;
}
